<template>
  <svg
    class="lp-loading"
    :style="{
      'max-width': `${radius * 2}px`,
      'max-height': `${radius * 2}px`,
    }"
  >
    <circle
      class="lp-loading-circle"
      :stroke="color"
      :stroke-width="stroke"
      stroke-linecap="round"
      fill="none"
      :r="normalizedRadius"
      :cx="radius"
      :cy="radius"
      pathLength="100"
    />
  </svg>
</template>
<script setup lang="ts">
import { computed } from 'vue'
defineOptions({
  name: 'lp-loading',
})

interface Props {
  stroke: number
  radius: number
  color: string
}
const props = withDefaults(defineProps<Props>(), {
  stroke: 6,
  radius: 32,
  color: 'var(--primary)',
})
const normalizedRadius = computed(() => props.radius - props.stroke / 2)
</script>
